module.exports = __webpack_public_path__ + "img/logo-actividades.dd72b277.webp";